import { render } from "./DialogComponent.vue?vue&type=template&id=6b1dd636"
import script from "./DialogComponent.vue?vue&type=script&lang=js"
export * from "./DialogComponent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2816855756/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__